import { render } from "./footer.vue?vue&type=template&id=52606b71&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=52606b71&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52606b71"]])

export default __exports__